import type { ReportComponent } from './schemas'

export const REPORT_COMPONENT_KO = {
  COVER: '표지',
  MONTHLY: '월별분석',
  COMMENT: '선생님의견',
  WEEKLY: '주별분석',
  LEVEL: '난이도별분석',
  STUDY_HISTORY: '학습내역',
  STUDY_PERFORMANCE: '학습성과',
  SCORING_RESULT: '진단결과',
  STUDY_EVALUATION: '학습평가',
} as const satisfies Record<ReportComponent, string>
